import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import StatusOptionsMulti from '../../components/psc/lib/StatusOptionsMulti'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'
import InfoModal from '../../components/psc/lib/InfoModal'

const TypecodeGroups = () => {
    const table = useRef(null)
    const urlGetData = '/v0/typecode_groups'
    const localStorageOrderKey = 'tblTypecodeGroupsOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const [showInfoModal, setShowInfoModal] = useState(false)

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' },
        { data: 'cadm_object.name' },
    ]

    const tableHead = (
        <tr>
            <th>Name</th>
            <th>Configured Item</th>
        </tr>
    )

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/typecode_groups/${row.id}`),
        1: (data, type, row) => linkSlot(data, type, row, `/cadm/typecode_groups/${row.id}`),
    }

    const modalContent = (
        <div>
            <div className="modal-item"> Customer documents don't use type-codes in their references, as these are defined by the issuing organisation.</div>
            <div className="modal-item"> However, to allow different sets of customer document types to be used across your portfolio, customer documents use type-codes and type-code maps.</div>
            <div className="modal-item"> Just add a single type-code for each customer document type-code map you want to build.</div>
            <div className="modal-item"> If only a single set of customer document types is needed across your entire portfolio, a single type-code can be mapped to your full set of customer document types.</div>
            <div className="modal-item"> Type-code maps for customer documents are applied to projects and products through configuration schemes, in the same way as for documents and records. </div>
        </div>
    )

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Type-Code Lists</h2>

                            <div className="pre-table-buttons">
                                <Link to="/cadm/typecode_groups/new" className="btn btn-mr btn-primary" type="button">New Type-Code List</Link>
                                <Link to="/cadm/typecode_group_mappings">Type-Code Maps</Link>
                            </div>
                            
                            <InfoModal 
                                title="Using Type-Codes with Customer Documents"
                                titleIcon="fa fa-info-circle"
                                bodyContent={modalContent}
                                show={showInfoModal}
                                onClose={() => setShowInfoModal(false)}
                            />

                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <strong>Type-code lists</strong> are sets of <strong>type-codes</strong> for each of your <strong>configured items</strong> (including <strong>customer documents</strong>).

                                <a className="modal-question-circle" to="#"
                                    onClick={() => setShowInfoModal(true)}>
                                    <i className="fa fa-question-circle"></i>
                                </a> <br/>

                                <strong>Type-codes</strong> are related to your <strong>project and product document types</strong> using <strong>type-code maps</strong>. <br/>

                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                                <StatusOptionsMulti
                                    tableRef={table}
                                    statusColumnIndex="1"
                                    fetchUrl="/v0/cadm_objects"
                                    localStorageKey="typecode_groups-cadm-objects"
                                    placeholder="Select Configured Item..."
                                />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default TypecodeGroups
